import { render } from "./top.vue?vue&type=template&id=50dcb393&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"

import "./top.vue?vue&type=style&index=0&id=50dcb393&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50dcb393"

export default script